<template>
  <div style="padding: 10px">
    <h1 style="font-weight: 700">Blog</h1>
    <br />
    <p style="color: #444444; font-size: 1.1rem">
      I like to shair everithing I know with others and I'm writting only in my
      website. Use the search below to filter by title.
    </p>
    <br />
    <div class="mb-3">
      <input
        v-model="search"
        type="text"
        class="form-control"
        id="search_box"
        placeholder="Filter by title"
      />
    </div>
    <br />
    <!-- Popular posts -->
    <div v-if="search === ''">
      <h2 style="font-weight: 700">Most Popular</h2>
      <br />
      <div v-if="popularposts_fetched">
        <div
          v-for="post in popularposts.slice().reverse()"
          v-bind:key="post.id"
        >
          <div class="page_post">
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding: 5px;
              "
            >
              <div>
                <p
                  v-if="post.Ago"
                  style="color: rgb(80, 200, 120); font-weight: bold"
                >
                  {{ moment(post.date).fromNow() }}
                </p>
                <p v-else style="color: #44444; font-weight: bold">
                  {{ moment(post.date).format("LL") }}
                </p>
              </div>
              <p
                :style="
                  'color: ' +
                  colors[popularposts.slice().reverse().indexOf(post)] +
                  '; font-weight: bold; font-size: 1.1rem'
                "
              >
                <img
                  style="height: 1rem"
                  src="../assets/icons/eye-solid.svg"
                  alt=""
                />
                {{ post.views }}
              </p>
            </div>
            <router-link
              v-bind:to="'/blog/' + post.id"
              style="text-decoration: none; color: black"
            >
              <div
                v-html="post.title"
                class="h5"
                style="
                  overflow-wrap: break-word;
                  font-weight: bold;
                  margin-bottom: 10px;
                "
              ></div>
            </router-link>
            <p
              v-if="post.RM"
              v-html="
                post.desc.substring(0, 100) +
                '...<span style=\'text-decoration: underline; color: rgb(13, 110, 253); cursor: pointer;\'>Read More</span>'
              "
              style="
                border-left: 5px solid rgb(255, 174, 0);
                padding: 10px;
                overflow-wrap: break-word;
                text-align: left;
                font-size: medium;
              "
            ></p>
            <p
              v-else
              v-html="post.desc"
              style="
                border-left: 5px solid rgb(255, 174, 0);
                padding: 10px;
                overflow-wrap: break-word;
                text-align: left;
                font-size: medium;
              "
            ></p>
          </div>
          <br />
        </div>
      </div>
      <div v-else>
        <div style="margin: auto; width: fit-content">
          <div class="spinner-border m-5" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
      <br />
    </div>
    <!-- All posts -->
    <h2 style="font-weight: 700">All Posts</h2>
    <br />
    <div v-if="posts_fetched">
      <div v-for="post in filteredposts" v-bind:key="post.id">
        <div style="font-family: Noto Sans">
          <div
            style="display: flex; justify-content: space-between; padding: 5px"
          >
            <div>
              <p
                v-if="post.Ago"
                style="color: rgb(80, 200, 120); font-weight: bold"
              >
                {{ moment(post.date).fromNow() }}
              </p>
              <p v-else style="color: #44444; font-weight: bold">
                {{ moment(post.date).format("LL") }}
              </p>
            </div>
            <p style="font-weight: bold">
              <img
                style="height: 1rem"
                src="../assets/icons/eye-solid.svg"
                alt=""
              />
              {{ post.views }}
            </p>
          </div>
          <router-link
            v-bind:to="'/blog/' + post.id"
            style="text-decoration: none; color: black"
          >
            <div
              v-html="post.title"
              class="h5"
              style="
                overflow-wrap: break-word;
                font-weight: bold;
                margin-bottom: 10px;
              "
            ></div>
          </router-link>
          <p
            v-if="post.RM"
            v-html="
              post.desc.substring(0, 100) +
              '...<span style=\'text-decoration: underline; color: rgb(13, 110, 253); cursor: pointer;\'>Read More</span>'
            "
            style="
              border-left: 5px solid rgb(255, 174, 0);
              padding: 10px;
              overflow-wrap: break-word;
              text-align: left;
              font-size: medium;
            "
          ></p>
          <p
            v-else
            v-html="post.desc"
            style="
              border-left: 5px solid rgb(255, 174, 0);
              padding: 10px;
              overflow-wrap: break-word;
              text-align: left;
              font-size: medium;
            "
          ></p>
        </div>
        <br />
        <br />
      </div>
    </div>
    <div v-else>
      <div style="margin: auto; width: fit-content">
        <div class="spinner-border m-5" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.page_post {
  color: black;
  background-color: whitesmoke;
  padding: 10px;
  border-radius: 10px;
  font-family: Noto Sans;
}
</style>
<script>
import {
  getDatabase,
  ref,
  onValue,
  orderByChild,
  query,
  limitToLast,
} from "@firebase/database";
import moment from "moment";
export default {
  name: "Blog",
  methods: {
    moment,
  },
  data() {
    return {
      colors: ["#ffae00", "silver", "#cd7f32"],
      posts: [],
      popularposts: [],
      search: "",
      popularposts_fetched: false,
      posts_fetched: false,
    };
  },
  computed: {
    filteredposts: function () {
      return this.posts.filter((post) => {
        return post.title.match(this.search);
      });
    },
  },
  created() {
    const db = getDatabase();
    const allPosts = query(ref(db, "blog/posts"), orderByChild("rid"));
    const popularPosts = query(
      ref(db, "blog/posts"),
      orderByChild("views"),
      limitToLast(3)
    );
    onValue(
      allPosts,
      (snapshot) => {
        snapshot.forEach((childSnapshot) => {
          var max_desc_width = 100;
          var postarray = childSnapshot.val();
          if (childSnapshot.val().desc.length > max_desc_width) {
            postarray.RM = true;
          }
          if (moment().diff(childSnapshot.val().date, "days") <= 5) {
            postarray.Ago = true;
          } else {
            postarray.Ago = false;
          }
          this.posts.push(postarray);
        });
        this.posts_fetched = true;
      },
      {
        onlyOnce: true,
      }
    );
    onValue(
      popularPosts,
      (snapshot) => {
        snapshot.forEach((childSnapshot) => {
          var max_desc_width = 100;
          var postarray = childSnapshot.val();
          if (childSnapshot.val().desc.length > max_desc_width) {
            postarray.RM = true;
          }
          if (moment().diff(childSnapshot.val().date, "days") <= 5) {
            postarray.Ago = true;
          } else {
            postarray.Ago = false;
          }
          this.popularposts.push(postarray);
        });
        this.popularposts_fetched = true;
      },
      {
        onlyOnce: true,
      }
    );
  },
};
</script>
